import {Card, CardGroup, Col, Row} from 'react-bootstrap';
import {useEffect, useState} from "react";
import {getSortedProjects} from "../../../db/projectStore";
import {Link} from "react-router-dom";

export const ProjectsOverviewPage = () => {
  const [projects, setProjects] = useState([]);
  
  useEffect(() => {
    const sortedProjects = getSortedProjects();
    setProjects(sortedProjects);
  }, []);

  return (
    <Row xs={1} md={2} className="g-3">
      {projects.map((project, index) => (
        <Col key={index + project.id} className="d-flex">
          <Link to={`/projects/${project.path}`} style={{textDecoration: 'none', display: 'flex', width: '100%'}}>
            <Card className='text-bg-light w-100 h-100'>
              <Card.Img variant="top" src={project.coverImage} style={{filter: 'grayscale(100%)'}}/>
              <Card.Body>
                <Card.Title>{project.title}</Card.Title>
                <Card.Text style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minHeight: '3em'
                }}>{project.caption}</Card.Text>
              </Card.Body>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
  )
}